"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Redirector = void 0;
const util_1 = require("@app/util");
class Redirector {
    constructor(options) {
        this.params = {};
        console.log('Redirector constructor');
        this._initSession();
        this.request = new util_1.Request(this.endpoint, this.session);
        this.initParams(); // get or cookies params
        this.initializeOptions(options);
        try {
            this.initConnections();
        }
        catch (e) {
            console.error('Redirector: initConnections error', e);
        }
    }
    initParams() {
        console.log('Init params, lets search query params in url');
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        this.params.to = urlParams.get('to');
        this.params.toSource = urlParams.get('toSource');
        this.params.subId = urlParams.get('subId');
        this.params.other = urlParams.get('other');
        Object.keys(this.params).forEach((key) => {
            if (!this.params[key]) {
                console.log('deleted');
                delete this.params[key];
            }
        });
    }
    async refresh() {
        console.log('Redirector: refresh, requesting new offer');
        this.params.other = '1';
        await this.initConnections();
    }
    _initSession() {
        if (window.bicrmTracking) {
            console.log('Redirector: bicrmTracking exists');
            this.session = window.bicrmTracking.session;
            this.shortId = this.session.getShortId();
        }
        else {
            throw new Error('Redirector: bicrmTracking not found');
        }
    }
    initializeOptions(options) {
        if (!options.endpoint) {
            throw new Error('RedirectorOptions.endpoint is required');
        }
        if (!!options.delayMs) {
            this.delayMs = options.delayMs;
        }
        else {
            this.delayMs = 1000;
        }
        this.endpoint = options.endpoint.replace('[shortId]', this.shortId);
        this.onPing3Success = options.onPing3Success;
    }
    async initConnections() {
        const response = await this.request.post(this.endpoint, this.params);
        const { status, url } = response;
        this.onPing3Success?.(response);
        window.bicrmTracking.track('waiting_page_redirect', {
            status,
            redirect_url: url,
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'WaitingPageRedirect', status, redirect_url: url });
        console.log('Redirector: initConnections', status, url);
        await new Promise(resolve => setTimeout(resolve, this.delayMs));
        document.location = url;
    }
}
exports.Redirector = Redirector;
